var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('p',[_vm._v("合作与服务：0431-81782288")]),_c('p',[_vm._v("Copyright 2019-2023 XJL. All Rights Reserved")]),_c('p',[_vm._v("地址：吉林省长春市南关区南环城路1088号B1号楼401室")]),_c('p',[_vm._v("邮政编码：130000 吉林省饮食文化研究会 版权所有")]),_c('p',[_c('a',{attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("吉ICP备17005125号-1")])])])
}]

export { render, staticRenderFns }